import React, { useCallback, useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import useFetch from '../../hooks/useFetch';
// import MainLayout from '../../layouts/MainLayout';
import 'react-datepicker/dist/react-datepicker.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { useLocation } from 'react-router-dom';
import Loader from '../../components/utils/Loader';
import Tooltip from '../../components/utils/Tooltip';

const MentorsList = () => {
  const location = useLocation();
  const authState = useSelector(state => state.authReducer);
  const [userId, setUserId] = useState(authState.user._id);
  const [mentors, setMentors] = useState([]);
  const [fetchData, { loading }] = useFetch();
  const [mentorType, setMentorType] = useState('');
  const [selectedMentorId, setSelectedMentorId] = useState(null);

  const fetchMentors = useCallback((mentorType) => {
    const config = {
        url: "/mentors/my",
        method: "post",
        headers: { Authorization: authState.token },
        data: { userId: userId }
    };
    // console.log("Getting my mentor",config);

    
    fetchData(config, { showSuccessToast: false })
        .then(response => {
            // console.log("Response:", response);
            if (response && Array.isArray(response.mentors)) {
                setMentors(response.mentors);
            } else {
                console.error("Invalid response format: mentors not found in response");
            }
        })
        .catch(error => {
            console.error("Error fetching mentors:", error);
        });
  }, [authState.token, fetchData, userId]);

  useEffect(() => {
      if (!authState.isLoggedIn) return;
      fetchMentors();
    }, [authState.isLoggedIn, fetchMentors]);

    const handleView = (mentorId) => {
      setSelectedMentorId(prevId => (prevId === mentorId ? null : mentorId));
    };

    const handleMentorShare = (mentorId) => {
      setSelectedMentorId(mentorId);
    };

    const handleMentorSave = (mentorId) => {
      setSelectedMentorId(mentorId);
    };

    const handleMentorPrint = (mentorId) => {
      setSelectedMentorId(mentorId);
    };

    const formatDateTime = (date) => {
      const options = {
          year: 'numeric', month: '2-digit', day: '2-digit',
          hour: '2-digit', minute: '2-digit', second: '2-digit',
          hour12: false
      };
      const jsDate = new Date(date);
      const day = jsDate.getDate().toString().padStart(2, '0');
      const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
      const year = jsDate.getFullYear();
      const hours = jsDate.getHours().toString().padStart(2, '0');
      const minutes = jsDate.getMinutes().toString().padStart(2, '0');
      const seconds = jsDate.getSeconds().toString().padStart(2, '0');
      return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  };

  const sortedMentors = [...mentors].sort((a, b) => new Date(b.dateCreated) - new Date(a.dateCreated));

  return (
    <>
      <div className="min-h-screen bg-black text-white [&_p]:text-white py-2">
        <div>
          <h2 className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>Learning - My Mentors</h2>
        </div>
        <div className="my-2 mx-auto max-w-[700px] py-4">
          <div className="border border-gray-300 p-4 mt-4">
            <div className="mt-2">
              <div className="mt-2">
                {mentors && mentors.length !== 0 && (
                  <div className="flex justify-between items-center border-b border-b-gray-300">
                    <div>
                    <h3 className='text-xl mt-1 mx-2 text-white'>{mentors.length} Mentors Found!</h3>
                    </div>
                    <div className='mr-1'>
                    <Link to='/mentors/add' className='block w-8 h-full px-2 py-1 ml-4 bg-blue-500'>
                      <FontAwesomeIcon className="bg-blue-500" icon={faPlus} />
                    </Link>
                  </div>
                </div>
                )}
              </div>
            </div>
            {loading ? (
              <Loader />
            ) : (
              <div className='text-sm'>
                {mentors && mentors.length === 0 ? (
                  <div className='w-[600px] h-[300px] flex items-center justify-center gap-4 text-yellow-300'>
                    <div className="flex justify-between items-center">
                    <div>
                    <h3 className='text-xl mt-1 mx-2 text-orange-400'>No Record Found!</h3>
                    </div>
                    <div>
                    <Link to='/mentors/add' className='block w-full h-full px-1 py-2 ml-4 bg-blue-500'>
                      <FontAwesomeIcon className="bg-blue-500 mr-4" icon={faPlus} />  Add New
                    </Link>
                  </div>
                </div>
                  </div>
                ) : (
                  sortedMentors.map((mentor, index) => (
                    <div key={mentor._id} className='bg-white my-1 p-2 text-gray-600 rounded-md shadow-md'>
                      <div className='flex'>
                        <span className='font-medium'>#{index + 1}. {mentor.mentorName}</span>
                        <Tooltip text={"View details"} position={"top"}>
                          <span className='ml-auto mr-2 text-blue-500 cursor-pointer' onClick={() => handleView(mentor._id)}>
                            <i className="fa-solid fa-eye"></i>
                          </span>
                        </Tooltip>
                        <Tooltip text={"Edit this record"} position={"top"}>
                          <Link to={`/mentors/${mentor._id}`} className='mr-2 text-green-600 cursor-pointer'>
                            <i className="fa-solid fa-pen"></i>
                          </Link>
                        </Tooltip>
                        <Tooltip text={"Delete this record"} position={"top"}>
                            <Link to={`/mentors/${mentor._id}`} className='mr-2 text-green-600 cursor-pointer'>
                                <i className="fa-solid fa-trash"></i>
                            </Link>
                        </Tooltip>
                      </div>
                      {selectedMentorId === mentor._id && (
                        <div className='bg-gray-200 text-black'>
                          <p className='text-blue-500'>{mentor.mentorName}</p>
                          <p>{mentor.mentorType}</p>
                          <p><strong>Mentoring Since:</strong> {formatDateTime(mentor.dateCreated)}</p>
                          <p><strong>Remarks:</strong> {mentor.remarks}</p>                       
                          <Tooltip text={"Share"} position={"top"}>
                            <span className='text-green-500 cursor-pointer mr-4' disabled={true} onClick={() => handleMentorShare(mentor._id)}>
                              <i className="fa-solid fa-share"></i>
                            </span>
                          </Tooltip>
                          <Tooltip text={"Save"} position={"top"}>
                            <span className='text-blue-500 cursor-pointer mr-4' disabled={true} onClick={() => handleMentorSave(mentor._id)}>
                              <i className="fa-solid fa-save"></i>
                            </span>
                          </Tooltip>
                          <Tooltip text={"Print"} position={"top"}>
                            <span className='text-orange-500 cursor-pointer mr-4' disabled={true} onClick={() => handleMentorPrint(mentor._id)}>
                              <i className="fa-solid fa-print"></i>
                            </span>
                          </Tooltip>
                        </div>
                      )}
                    </div>
                  ))
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default MentorsList

